import { CompanionAds } from '@lib/iab/iab-vast-model';

import createCompanion from './companion';

interface UnmarshalerNode {
    _value: unknown;
    [key: string]: unknown;
}

interface ICreativeCompanionAds {
    companionAds: {
        required: string;
        companion: UnmarshalerNode[];
        _value: Element;
    };
}

const createCompanionAds = ($creative: ICreativeCompanionAds): CompanionAds => {
    const $companionAds = $creative.companionAds;
    const companionAds = new CompanionAds();
    companionAds.required = $companionAds.required;
    if ($companionAds.companion != null) {
        companionAds.companions.push(
            ...$companionAds.companion.map(createCompanion)
        );
    }
    companionAds.xmlElement = $companionAds._value;
    return companionAds;
};

export default createCompanionAds;
